import React from 'react';
import { Box, Typography, Button, Alert } from '@mui/material';
import { COLOR_PRIMARY_2 } from 'src/utils/colors';
import { useCreateAffiliateLink } from './hooks';
import FullScreenLoader from 'src/App/Dashboards/Market/Components/Loaders/FullScreenAnimationLoader';

const CreateAffiliateLink = () => {
  const {
    isCreateAffiliateLinkLoading,
    createAffiliateLinkError,
    createAffiliateLink,
  } = useCreateAffiliateLink();

  return (
    <>
      <Box
        sx={{
          m: 3,
          p: 2,
          boxShadow: 3,
          borderRadius: 2,
          bgcolor: '#fff',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box>
          {createAffiliateLinkError && (
            <Alert severity="error" sx={{ width: '100%' }}>
              {createAffiliateLinkError}
            </Alert>
          )}
          <Typography variant="h6" fontWeight={700} gutterBottom>
            Airbtics Affiliate Program
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Apply to become an Airbtics affiliate! Earn commissions by referring property investors
            and Airbnb hosts to our analytics platform.
          </Typography>
        </Box>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={createAffiliateLink}
          sx={{ maxWidth: 200, mt: 2, background: COLOR_PRIMARY_2, color: '#fff' }}
        >
          Join Our Affiliate Program
        </Button>
      </Box>

      {isCreateAffiliateLinkLoading && <FullScreenLoader />}
    </>
  );
};

export default CreateAffiliateLink;
